$ = require 'jquery'
Backgrounds = require 'data/backgrounds'
Browser = require 'lib/browser'
Util = require 'lib/util'
_ = require 'underscore'
md5 = require 'blueimp-md5'
Promise = require 'bluebird'

module.exports = new class

  constructor: ->
    @settings = {}
    @_update = _.debounce(@_update, 100).bind(@)
    @_hasher = _.memoize md5

  # http://stackoverflow.com/a/3368118/62055
  roundRect = (ctx, x, y, width, height, radius, fill, stroke) ->
    stroke ?= true
    radius ?= 5
    ctx.beginPath()
    ctx.moveTo(x + radius, y)
    ctx.lineTo(x + width - radius, y)
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius)
    ctx.lineTo(x + width, y + height - radius)
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height)
    ctx.lineTo(x + radius, y + height)
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius)
    ctx.lineTo(x, y + radius)
    ctx.quadraticCurveTo(x, y, x + radius, y)
    ctx.closePath()
    if (stroke)
      ctx.stroke()
    if (fill)
      ctx.fill()

  drawFavicon: (img) ->
    canvas = document.createElement('canvas')
    canvas.width = canvas.height = 64

    if !(ctx = canvas.getContext?('2d'))?
      throw Error("Can't render to the canvas!")

    ctx.save()

    if img?
      roundRect ctx, 0, 0, 64, 64, 8, false, false
      ctx.clip()

      if @settings.tiled
        ctx.drawImage(img, 0, 0)
      else
        { width, height } = img
        if width > height
          ctx.drawImage(img, 0, 0, 64 * width / height, 64)
        else
          ctx.drawImage(img, 0, 0, 64, 64 * height / width)
    else
      if @settings.useDefault
        defaultFill = ctx.createLinearGradient(0, 0, 0, 32)
        defaultFill.addColorStop(0, '#298FCA')
        defaultFill.addColorStop(1, '#0079BF')
        ctx.fillStyle = defaultFill
      else
        ctx.fillStyle = @settings.color ? Backgrounds.blue.color

      roundRect ctx, 0, 0, 64, 64, 12, true

    ctx.fillStyle = "#fff"

    roundRect ctx, 9, 9, 19, 44, 6, true
    roundRect ctx, 36, 9, 19, 29, 6, true

    ctx.restore()

    if @settings.hasNotifications
      radius = 15
      ctx.beginPath()
      ctx.arc(64 - radius, radius, radius, 0, 2 * Math.PI, false)
      ctx.fillStyle = "#EB5A46"
      ctx.fill()
      ctx.lineWidth = 4
      ctx.strokeStyle = "#FFFFFF"
      ctx.stroke()
      ctx.closePath()

    canvas.toDataURL('image/png')

  _update: ->
    if !Browser.allowsDynamicFavicon()
      return

    Promise.try =>
      if @settings.url?
        new Promise (resolve, reject) =>
          img = document.createElement('img')
          img.setAttribute('crossorigin', 'anonymous')
          img.onload = -> resolve(img)
          img.onerror = (err) -> reject(err)
          img.src = "#{@settings.url}?favicon"
    .then (img) =>
      href = @drawFavicon(img)
      $('#favicon').remove()
      $('<link>')
      .attr
        id: 'favicon'
        rel: 'icon'
        type: 'image/png'
        sizes: '64x64'
        href: href
      .appendTo('head')
    .catch(->)
    .done()

  setNotifications: (hasNotifications) ->
    @settings.hasNotifications = hasNotifications

    @_update()

  setBackground: ({ url, tiled, color, useDefault }) ->

    @settings.url = url
    @settings.tiled = tiled
    @settings.color = color
    @settings.useDefault = useDefault

    @_update()



// WEBPACK FOOTER //
// ./app/scripts/lib/favicon.coffee